import { take } from 'rxjs/operators';

import { SelectionModel } from '@angular/cdk/collections';

export class SnSelectionModel<T> extends SelectionModel<T> {
  public dirty = false;

  constructor(
    _multiple?: boolean,
    initiallySelectedValues?: T[],
    private readonly _trackByFn?: (item: T) => any,
    _emitChanges?: boolean,
  ) {
    super(_multiple, initiallySelectedValues, _emitChanges);
    this._initSubscription();
  }

  public isSelected(value: T): boolean {
    if (this._trackByFn) {
      const index = this.selected.findIndex((selectedItem: T) => {
        return this._trackByFn(selectedItem) === this._trackByFn(value);
      });

      return index !== -1;
    }

    return super.isSelected(value);
  }

  public select(...values: T[]): void {
    if (this._trackByFn) {
      values.forEach((value) => {
        if (!this.isSelected(value)) {
          super.select(value);
        }
      });
    } else {
      super.select(...values);
    }
  }

  public deselect(...values: T[]): void {
    if (this._trackByFn) {
      values.forEach((value) => {
        if (this.isSelected(value)) {
          const item = this.selected.find((selectedItem: T) => {
            return this._trackByFn(selectedItem) === this._trackByFn(value);
          });

          super.deselect(item);
        }
      });
    } else {
      super.deselect(...values);
    }
  }

  public toggle(value: T): void {
    if (this._trackByFn) {
      this.isSelected(value) ? this.deselect(value) : this.select(value);
    } else {
      super.toggle(value);
    }
  }

  public markAsDirty(): void {
    this.dirty = true;
  }

  private _initSubscription(): void {
    this.changed.pipe(take(1)).subscribe(() => this.markAsDirty());
  }
}
